import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "src/environments/environment";

class ConfigResponse {
  apiEndpoint: string;
  showDocumentList: boolean;
  clientId: string;
  tenantId: string;
}

@Injectable()
export class AppConfigService {
  private appConfig: ConfigResponse;

  constructor(private http: HttpClient) {}

  loadAppConfig() {
    if (environment.apiEndpoint) {
      this.appConfig = {
        apiEndpoint: environment.apiEndpoint,
        showDocumentList: true,
        clientId: environment.clientId,
        tenantId: environment.tenantId,
      };
      return Promise.resolve();
    }

    return this.http
      .get("/config")
      .toPromise()
      .then((data: ConfigResponse) => {
        this.appConfig = data;
      });
  }

  getConfig(): ConfigResponse {
    return this.appConfig;
  }
}
